import * as yup from "yup";

export const BannerValidation = yup.object().shape({
    sanstha_id: yup.object().required("Required"),
    status: yup.string().required("Required"),
});